import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import DatasetEditService from '../service/DatasetEditService';
import FieldType from '../dto/FieldType';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	return {
		key: 'datasetEditForm',
		topic: 'dataset',
		service: DatasetEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'keyFields' }, { key: 'valueFields' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'description',
					component: EditFormTextField,
					multiline: true
				},
				{
					key: 'keyFields',
					tab: 'keyFields',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						type: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(FieldType).map(key => {
								return { label: FieldType[key], value: key };
							})
						}
					]
				},
				{
					key: 'valueFields',
					tab: 'valueFields',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						type: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(FieldType).map(key => {
								return { label: FieldType[key], value: key };
							})
						}
					]
				}
			];

			return fields;
		}
	};
};

function DatasetEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(DatasetEditForm);
